import {css} from '@emotion/react'
import Map from './Map.jsx'
import {SecondarySideBar, SecondarySideBarProvider} from './SecondarySideBar.jsx'

const cssSoftwareMap = css({
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    overflow: 'hidden',
})

export default function SoftwareMap({className, style, ...props}) {
    return (
        <div
            className={className}
            style={style}
            css={cssSoftwareMap}
        >
            <SecondarySideBarProvider>
                <Map {...props} />
                <SecondarySideBar />
            </SecondarySideBarProvider>
        </div>
    )
}
